import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    feedbackDuration: { type: Number, default: 2000 }
  }

  copy() {
    const text = this.sourceTarget.textContent.trim()

    navigator.clipboard.writeText(text).then(() => {
      this.showFeedback("Copied!")
    }).catch(() => {
      this.showFeedback("Failed")
    })
  }

  showFeedback(message) {
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = message
    this.buttonTarget.disabled = true

    setTimeout(() => {
      this.buttonTarget.textContent = original
      this.buttonTarget.disabled = false
    }, this.feedbackDurationValue)
  }
}
